module.exports = __webpack_public_path__ + "static/oopstypo-a18c8af05e8277718887dc32a871155e.svg";